class TotalFileSizeExceededError extends Error {
  constructor() {
    super(
      "Die hochgeladenen Dateien dürfen zusammen 50 MB nicht übersteigen."
    );
  }

  static type = "maximum_file_size";
}

class InvalidFileTypeError extends Error {
  constructor() {
    super("Bitte lade nur Dateien in einem der folgenden Dateiformate hoch: JPEG, PNG, TIFF, DOC, DOCX, XLS, XLSX und PDF.");
  }

  static type = "invalid_file_type";
}

class DocumentUploadError extends Error {
  constructor(status) {
    if (status === "rejected_file_type") {
      return new InvalidFileTypeError();
    }

    super(`Unexpected error: ${status}`);
  }

  static type = "document_upload_error";
}

export {
  DocumentUploadError,
  InvalidFileTypeError,
  TotalFileSizeExceededError,
};
